import { connect, ConnectedProps } from 'react-redux';
import { RootState } from '../../store/root-reducer';

import Dialer from './dialer';

const mapStateToProps = (state: RootState) => ({
  
});

const mapDispatchToProps = {
  
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type IProps = ConnectedProps<typeof connector>;

export default connector(Dialer);
